import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import Filter from "../../Assets/Images/CommanImages/filter.png";
import columnaddition from "../../Assets/Images/CommanImages/rectangleplus.png";
import updown from "../../Assets/Images/CommanImages/updown.png";
import searchicon from "../../Assets/Images/CommanImages/searchyellow.png";
import leftArrow from "../../Assets/Images/CommanImages/Larrowbar.png";
import rightArrow from "../../Assets/Images/CommanImages/Rarrowbar.png";
import FileExport from "../../Assets/Images/CommanImages/fileexport.png";
import InterogativeImg from "./../../Assets/Images/CommanImages/Warning.png";
import SelectedValuesDropdown from "../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { FULL_API_BASE_URL } from "../../Config/Config";
import BatchTableDetails from "./BatchTableDetails";

const BatchDashboard = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
  setPagePath,
  setNoTimeSet,
}) => {
  const [reportDashboardData, setReportDashboardData] = useState([]);
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("other");
  const [headers, setHeaders] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (dataClient) {
      fetchDashboardData();
    }
  }, [dataClient]);

  const userId = dataClient?.client_schema_name?.[6]?.[0]?.user_id;
  const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name;
  const clientBranchId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;

  const fetchDashboardData = async () => {
    setNoTimeSet(true);
    setIsLoading(true);
    setIsMessageBoxVisible(true);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span style={{ marginLeft: "10px", marginTop: "3px" }}>
            Loading data, please wait...
          </span>
        </div>
      </div>
    );
    setActiveImg(false);

    const slowLoadingTimer = setTimeout(() => {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span style={{ marginLeft: "10px", marginTop: "3px" }}>
              This is taking longer than usual, please wait a moment...
            </span>
          </div>
        </div>
      );
    }, 5000);

    try {
      const response = await fetch(
        `${FULL_API_BASE_URL}/get-batch-dashboard?client_branch_id=${clientBranchId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(
          "Failed to fetch dashboard data. Please check the API or authentication details."
        );
      }

      const result = await response.json();

      if (
        result.status === 200 &&
        result.message === "Batch dashboard fetched successfully"
      ) {
        const tableData = result?.table_data || [];

        const headerStrings = tableData.filter(
          (item) => typeof item === "string"
        );
        const rows = tableData.filter(
          (item) => typeof item === "object" && item !== null
        );

        const formattedHeaders = headerStrings.map((header) =>
          String(header).replace(/^[a-zA-Z]\*/, "")
        );

        const headerKeys = rows.length > 0 ? Object.keys(rows[0]) : [];

        const transformedRows = rows.map((row) =>
          headerKeys.map((key) => {
            const cell = row[key];
            if (cell === "" || cell === null || cell === undefined)
              return "---";
            return cell;
          })
        );

        setHeaders(formattedHeaders);
        setReportDashboardData(transformedRows);
        clearTimeout(slowLoadingTimer);
        setIsLoading(false);
        setNoTimeSet(false);
        setIsMessageBoxVisible(false);
      } else {
        clearTimeout(slowLoadingTimer);
        setIsLoading(false);
        setNoTimeSet(false);
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <span style={{ marginLeft: "10px", marginTop: "3px" }}>
                {result.message || "Failed to fetch data. Please try again."}
              </span>
            </div>
          </div>
        );
        console.error("API returned non-success response:", result);
      }
    } catch (error) {
      clearTimeout(slowLoadingTimer);
      setIsLoading(false);
      setNoTimeSet(false);
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span style={{ marginLeft: "10px", marginTop: "3px" }}>
              Error: {error.message}
            </span>
          </div>
        </div>
      );
      console.error("Error fetching dashboard data:", error);
    }
  };

  const selectedBatchId = selectedRows[0];
  const row = reportDashboardData.find((item) => item[0] === selectedBatchId);

  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "37px",
        marginBottom: "40px",
      }}
    >
      <div className="">
        <div
          style={{
            backgroundColor: "white",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            zIndex: 1001,
            top: 0,
          }}
        >
          <p style={{ color: "rgb(47, 46, 64)", fontSize: "30px" }}>
            Batch Dashboard
          </p>
          <div style={{ display: "flex" }}>
            <button
              style={{
                padding: "12px",
                marginRight: "18px",
                boxShadow: "0px 4px 4px 0px #00000040",
                marginTop: "0",
                opacity: selectedRows.length === 0 ? 0.5 : 1,
                cursor: selectedRows.length === 0 ? "not-allowed" : "pointer",
                width: "160px",
              }}
              className="create-test-section-btn"
              onClick={() => {
                if (selectedRows.length > 0) {
                  const selectedBatchId = selectedRows[0];
                  const row = reportDashboardData.find(
                    (item) => item[0] === selectedBatchId
                  );
                  if (row) {
                    navigate(
                      `/assign_batch?batch_id=${row[0]}&session_id=${row[4]}&course_id=${row[7]}&class_id=${row[5]}&class_type=${row[12]}`
                    );
                  }
                }
              }}
              disabled={selectedRows.length === 0}
            >
              ASSIGN STUDENTS
            </button>
            <button
              style={{
                padding: "12px",
                marginRight: "18px",
                boxShadow: "0px 4px 4px 0px #00000040",
                marginTop: "0",
              }}
              className="create-test-section-btn"
              onClick={() => {
                navigate(`/create_batch`);
              }}
            >
              NEW
            </button>
          </div>
        </div>
        <p style={{ marginTop: "1%", color: "#2F2E40" }}>
          Batch requests are listed here click on a ID to check status, edit or
          cancel the request or create a new request using New button.
        </p>
        <div>
          <BatchTableDetails
            headers={headers}
            data={reportDashboardData}
            searchPlaceholder="Filter Question Papers..."
            dataClient={dataClient}
            setPagePath={setPagePath}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            bulk={false}
          />
        </div>
      </div>
    </div>
  );
};

export default BatchDashboard;
